
// Predefined options for enums
export const proposalStatusOptions = [
    { key: "New", label: "New" },
    { key: "New - document created", label: "New - document created" },
    { key: "Pending - document sent", label: "Pending - document sent" },
    { key: "Accepted", label: "Accepted" },
    { key: "Accepted - Change Order", label: "Accepted - Change Order" },
    { key: "Proposal Rejected", label: "Proposal Rejected" },
    { key: "Expired", label: "Expired" }
];

export const calculationTypeOptions = [
    { key: "Price By Job", label: "Price By Job" },
    { key: "Price By Device", label: "Price By Device" },
    { key: "Price By Phase", label: "Price By Phase" }
];

export const installmentTypeOptions = [
    { key: "Use Percents", label: "Use Percents" },
    { key: "Use Currency Amounts", label: "Use Currency Amounts" },
    { key: "Time and Materials + Amount Entered", label: "Time and Materials + Amount Entered" },
    { key: "Time and Materials only", label: "Time and Materials only" },
    { key: "Maintenance - periodic", label: "Maintenance - periodic" }
];

export const proposalListFields = [

    { key: "actions", label: "Actions" },
    { key: "proposalNumber", label: "Proposal Number", type: "number", required: true },
    { key: "salesPerson", subKeys: ["firstName", "lastName"], label: "Sales Rep", type: "text", required: true },
    { key: "building", subKeys: ["buildingReference"], label: "Building Site", type: "text", required: true },
    {
        key: "proposalStatus",
        label: "Proposal Status",
        type: "select",
        options: proposalStatusOptions,
        required: true
    },
    { key: "submitDate", label: "Submit Date", type: "datetime-local", required: true, isDateOnly: true },
]

// MODALS

// Basic Information
export const proposalBasicInfo = [
    { key: "proposalNumber", label: "Proposal Number", type: "number", required: true, isDisabled: true },
    // { key: "salesId", label: "Sales Rep", type: "select", optionsKey: 'salesId', optionLabel: 'firstName', optionValue: 'id', required: true },
    // { key: "buildingId", label: "Building ID", type: "number", required: true, isDisabled: true },
    // { key: "salesPerson", subKeys: ["firstName", "lastName"], label: "Sales Rep", type: "select", required: true, optionLabel: "firstName", optionValue: "id", isViewOnly: true },
    { key: "building", subKeys: ["buildingReference"], label: "Building Site", type: "select", required: true, isDisabled: true },

    { key: "submitDate", label: "Submit Date", type: "datetime-local", required: true },
    { key: "startDate", label: "Start Date", type: "datetime-local", required: false },
];

// Proposal Status & Classification
export const proposalStatusInfo = [
    { key: "proposalStatus", label: "Proposal Status", type: "select", options: proposalStatusOptions, required: true },

    {
        key: "daysValid", label: "Days Valid", type: "number", required: false, min: 0, max: 29,
        condition: {
            key: "proposalStatus",
            values: ['New', 'New - document created', 'Pending - document sent', 'Expired']
        }
    },

    {
        key: "approvedBy", label: "Approved By", type: "text", required: false,
        condition: { key: "proposalStatus", values: ['Accepted'] }
    }, {
        key: "approvalDate", label: "Approval Date", type: "datetime-local", required: false,
        condition: { key: "proposalStatus", values: ['Accepted', 'Accepted - Change Order'] }
    },

    {
        key: "expirationDate", label: "Expiration Date", type: "datetime-local", required: false,
        condition: { key: "proposalStatus", values: ['Expired'] }
    },
    {
        key: "cancellationDate", label: "Cancellation Date", type: "datetime-local", required: false,
        condition: { key: "proposalStatus", values: ['Proposal Rejected'] }
    },
    {
        key: "cancelledBy", label: "Cancelled By", type: "text", required: false,
        condition: { key: "proposalStatus", values: ['Proposal Rejected'] }
    },
];



export const proposalClassInfo = [

    { key: "proposalClass", label: "Proposal Class", type: "select", optionsKey: 'proposalClass', optionLabel: "className", optionValue: "classId", required: true },
    { key: "proposalSubClass", label: "Proposal SubClass", type: "select", optionsKey: 'proposalSubClass', optionLabel: "subClassName", optionValue: "subClassId", required: true },
]

// Proposal Details
export const proposalDetailsInfo = [
    { key: "description", label: "Description", type: "textarea", required: false },
    { key: "taxExemptNumber", label: "Tax Exempt Number", type: "number", required: false },
    { key: "calculationType", label: "Calculation Type", type: "select", options: calculationTypeOptions, required: true },
    { key: "isTaxable", label: "Is Taxable?", type: "checkbox", required: true },
    { key: "numOfInstallments", label: "Number of Installments", type: "number", required: false },
    { key: "installmentType", label: "Installment Type", type: "select", options: installmentTypeOptions, required: false },

];


// Combined All Fields (For Full Form Usage)
export const proposalFields = [
    ...proposalBasicInfo,
    ...proposalStatusInfo,
    ...proposalDetailsInfo,

];

